import api from "."


export default {
    login: async (email, password) => {
        try {
            const res = await api.post("/api/auth/login", { email, password });
            return res.data;
        } catch (err) {
            console.error(err.message);
            return err.response.data;
        }
    },

    signup: async (name, email, password) => {
        try {
            const res = await api.post("/api/auth/register", { name, email, password });
            return res.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    profile: async () => {
        try {
            const res = await api.get("/api/profile");
            return res.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    changePassword: async (password, confirmedPassword) => {
        try {
            const res = await api.post("/api/profile/change-password", { password, confirmedPassword });
            return res.status === 200;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    logout: async () => {
        try {
            await api.post("/api/auth/logout");
            return true;
        } catch (err) {
            console.error(err.message);
            return false;
        }
    },

    getRole: async () => {
        try {
            const res = await api.get("/api/profile/role");
            return res.data;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    emailVerification: async (id, token) => {
        try {
            const res = await api.get(`/api/auth/verify/${id}/${token}`);
            return res.status === 200;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    resendVerification: async (email) => {
        try {
            const res = await api.get(`/api/auth/resend-verification?email=${email}`);
            return res.status === 200;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    resetPassword: async (email) => {
        try {
            const res = await api.post("/api/auth/reset-password", { email });
            return res.status === 200;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    },

    resetPasswordConfirm: async (id, token, password, confirmedPassword) => {
        try {
            const res = await api.post(`/api/auth/reset-password/${id}/${token}`, { password, confirmedPassword });
            return res.status === 200;
        } catch (err) {
            console.error(err.message);
            return null;
        }
    }
}